import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { LoginStore } from '../../stores/login-store';
import {
  InjectAPI,
  InjectApp,
  InjectHistory,
  InjectTranslate,
} from '../app/app';
import { ButtonGroup } from '../widgets/button-group';
import { Field } from '../widgets/field';
import { FormErrorsOverview } from '../widgets/form-errors-overview';
import { PrimaryButton } from '../widgets/primary-button';

type InjectedProps = InjectAPI & InjectApp & InjectHistory & InjectTranslate;

@withRouter
@inject('api', 'app', 't')
@observer
export class Login extends React.Component<InjectedProps> {
  private readonly store: LoginStore;

  constructor(props: InjectedProps) {
    super(props);
    this.store = new LoginStore(props.history, props.api, props.app);
  }

  public render() {
    const {
      store,
      props: { t },
    } = this;

    return (
      <form className="login container" onSubmit={store.handleClickLogin}>
        <div className="centered">
          <h1>{t('login.header')}</h1>
          <p>{t('login.subheader')}</p>
        </div>
        <Field
          label={t('common.reservation_number')}
          value={store.pnr}
          errors={store.lastLoginErrors.pnr}
          onChange={store.setPNR}
        />
        <Field
          label={t('common.last_name')}
          value={store.lastName}
          errors={store.lastLoginErrors.last_name}
          onChange={store.setLastName}
        />
        <br />
        <ButtonGroup>
          <PrimaryButton text={t('login.button')} disabled={store.loading} />
        </ButtonGroup>
        <FormErrorsOverview errors={store.lastLoginErrors} />

        <p
          className="login-support"
          dangerouslySetInnerHTML={{ __html: t('chrome.footer_html') }}
        />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/login/login.tsx